import { createRoot } from 'react-dom/client';
import App from './App';
import 'react-app-polyfill/stable';
import { initSentry } from 'utils/tracking';
import { LicenseInfo } from '@mui/x-license';
import { checkLocalStorage } from 'further-ui/utils';
import { LocalStorageError } from 'further-ui/components';

// Check localStorage availability before initializing the app
const localStorageCheck = checkLocalStorage();

if (!localStorageCheck.isAvailable) {
  const container = document.getElementById('root');
  if (container) {
    const root = createRoot(container);
    root.render(<LocalStorageError logoPath="images/logo.png" isAdminSite />);
  }
} else {
  LicenseInfo.setLicenseKey(process.env.REACT_APP_MUI_X_LICENSE_KEY ?? '');
  initSentry();

  const root = createRoot(document.getElementById('root')!);

  root.render(<App />);
}
